import React from 'react'
import './CollectionCard.css';
import {useNavigate} from 'react-router-dom';
export default function CollectionCard({ title,image }) {
    const navigate = useNavigate();
//on click function to navigate to collection page can be added later
const handleClick = () => {
    //navigation logic here
    localStorage.setItem('selectedCollection', JSON.stringify({ title,image }));
    navigate('/collection-page');
}


    //coment next line before deployment, this is just to prevent errors during development as the image data is not being passed correctly from the parent component
    
    return (
        <div className="card-wrap" onClick={handleClick} style={{backgroundImage: `url(${image})`, backgroundOrigin: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover',}}>

            <div className="collection-card" style={{  height: '300px',  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', padding: '20px', boxSizing: 'border-box' }}>

                <h2 className="collection-title">{title}</h2>
                
                
                {/* <div className="rela">

            </div> */}
            </div>
        </div>
    )
}